import * as yup from 'yup';

export const PastoralCareSchema = yup.object({
  church: yup.string().notRequired().nullable(),
  contactPerson: yup.string().notRequired().nullable(),
  anointingOfTheSick: yup.boolean().notRequired().nullable(),
  hospiceService: yup.string().notRequired().nullable(),
  terminalCare: yup.boolean().notRequired().nullable(),
  funeralHome: yup.string().notRequired().nullable(),
  funeralInformation: yup.string().notRequired().nullable(),
});

export interface IPastoralCare {
  church?: string;
  contactPerson?: string;
  anointingOfTheSick?: boolean;
  hospiceService?: string;
  terminalCare?: boolean;
  funeralHome?: string;
  funeralInformation?: string;
}

export const CreatePastoralCareSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(PastoralCareSchema);

export interface ICreatePastoralCare extends IPastoralCare {
  residentId: string;
}

export const UpdatePastoralCareSchema = yup
  .object({
    id: yup.string(),
  })
  .concat(PastoralCareSchema);

export interface IUpdatePastoralCare {
  id: string;
  church?: string | null;
  contactPerson?: string | null;
  anointingOfTheSick?: boolean;
  hospiceService?: string | null;
  terminalCare?: boolean;
  funeralHome?: string | null;
  funeralInformation?: string | null;
}
